import React from "react";
import AccountCard from "./AccountCard";

function getAccountBalance(account, holdings) {
    const type = account.type;
    const balances = account.balances || {};

    // For investment accounts, calculate from holdings
    if (type === "INVESTMENT" || type === "BROKERAGE") {
        const holdingsValue = holdings
            .filter((h) => h.accountId === account.accountId)
            .reduce((sum, h) => sum + (h.marketValue || 0), 0);
        // If no holdings found, fall back to account balance
        return holdingsValue > 0 ? holdingsValue : (balances.current || balances.available || 0);
    }

    // For all other account types, use current balance (or available as fallback)
    return balances.current ?? balances.available ?? 0;
}

function isLiability(type) {
    return type === "CREDIT" || type === "LOAN";
}

export default function AccountGrid({ accounts, holdings, onSelect }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {accounts.map((acct) => {
                const subtitle = acct.subtype;
                const rawValue = getAccountBalance(acct, holdings);
                const isDebt = isLiability(acct.type);

                return (
                    <AccountCard
                        key={acct.accountId}
                        name={acct.name}
                        subtitle={subtitle}
                        value={rawValue}
                        isLiability={isDebt}
                        onClick={() => onSelect(acct)}
                    />
                );
            })}
        </div>
    );
}
